// extracted by mini-css-extract-plugin
export default {"text":"text___a712b2cebfb22271","control":"control___cc97b298df5c7d88"};